import React, { useState, useEffect } from "react";
import { IconButton, Slider, Typography, Box } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const AudioPlayer = ({
  audioRef,
  sync,
  lyrics,
  onIconClick,
  isPlayingFromSync,
  setIsPlayingFromSync,
  setCurrentTimestamp,
  preview,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    sync && setIsPlaying(isPlayingFromSync);
  }, [isPlayingFromSync]);

  useEffect(() => {
    const audio = audioRef.current;

    const updateCurrentTime = () => {
      setCurrentTime(audio.currentTime);
      setCurrentTimestamp && setCurrentTimestamp(audio.currentTime);
      audio.currentTime === audio.duration && sync && setIsPlaying(false);
    };

    const handleLoadedMetadata = () => {
      setDuration(Math.floor(audio.duration));
    };
    if (audio.duration && duration === 0) {
      setDuration(Math.floor(audio.duration));
    }
    audio.addEventListener("timeupdate", updateCurrentTime);
    audio.addEventListener("loadedmetadata", handleLoadedMetadata);

    return () => {
      audio.removeEventListener("timeupdate", updateCurrentTime);
      audio.removeEventListener("loadedmetadata", handleLoadedMetadata);
    };
  }, [duration]);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
    setIsPlayingFromSync && setIsPlayingFromSync(!isPlaying);
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const handleSliderChange = (event, newValue) => {
    audioRef.current.currentTime = newValue;
    setCurrentTime(newValue);
  };

  const renderIcon = () => {
    if (sync && lyrics) {
      return <EditIcon color="primary" />;
    } else if (sync && !lyrics && !preview) {
      return <DeleteIcon color="error" />;
    } else {
      return null;
    }
  };

  return (
    <Box
      sx={{
        width: sync ? "75%" : "90%",
        display: "flex",
        // flexDirection: 'column',
        alignItems: "center",
        margin: "0 auto",
        backgroundColor: "#f5f5f5",
        borderRadius: "18px",
        padding: "2px",
        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box
        sx={{
          // marginTop: "-6px",
          "& :hover": {
            backgroundColor: "#142C5C",
            opacity: 0.8,
          },
        }}
      >
        <IconButton
          sx={{
            color: "white",
            backgroundColor: "#142C5C",
            padding: "8px",
            borderRadius: "50%",
            transition: "background-color 0.3s, opacity 0.3s",
            "&:hover": {
              backgroundColor: "#142C5C",
              opacity: 0.9,
            },
          }}
          onClick={togglePlayPause}
        >
          {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
        </IconButton>
      </Box>
      <Typography variant="body2" sx={{ margin: "0 7px", width: "65px" }}>
        {formatTime(currentTime)} / {formatTime(duration)}
      </Typography>
      {/* </Box> */}
      <Slider
        value={currentTime}
        min={0}
        max={duration}
        onChange={handleSliderChange}
        sx={{
          width: sync ? "80%" : "55%",
          marginLeft: "10px",
          "& .MuiSlider-thumb": {
            zIndex: 1,
            height: "10px",
            width: "10px",
            color: "#142C5C",
          },
        }}
      />
      <Box sx={{ marginLeft: "auto" }}>
        <IconButton onClick={onIconClick}>{renderIcon()}</IconButton>
      </Box>
    </Box>
  );
};

export default AudioPlayer;
